import { isNil } from 'lodash';

import rankDefault from 'Asset/image/rank-default.svg';
import rankEmpty from 'Asset/image/rank-empty.svg';
import rank3 from 'Asset/image/rank-3.svg';
import rank2 from 'Asset/image/rank-2.svg';
import rank1 from 'Asset/image/rank-1.svg';

const RANK_BADGE_MAP = {
  1: rank1,
  2: rank2,
  3: rank3,
};

const getRankBadge = (num) => {
  if (isNil(num)) return rankEmpty;

  return RANK_BADGE_MAP[num] ?? rankDefault;
};

export default getRankBadge;
